import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, Collapse, Row } from 'reactstrap';

type MenuTileProps = {
    tileLink: string;
    tileTitle: string;
    tileDescription: string;
    icon: any;
    tileType?: 'iframe' | 'fontawesome' | 'link' | null;
}


const MenuTile = (props: MenuTileProps) => {

    var iconstyle: any = { fontSize: '5.5rem' };
    if (props.tileType == 'iframe' || null) {
        if (props.icon.toString().indexOf("fa ") >= 0) {
           /* iconstyle["marginBottom"] = "1.4rem";*/
        }
    }

    const iframeRender = (
        <Link to={props.tileLink}>
            <Button className="taskLinkButton" style={{
                /*background:'#458bca',*/
                borderRadius: '1em',
                textAlign: 'center',
                height: '13em',
                width: '20em',
                marginBottom: '2em',
            }}><i className={props.icon.toString()} style={iconstyle}></i>
                <Row>
                    <Col>
                        <h4>{props.tileTitle}</h4>
                    </Col>
                </Row>
            </Button>
        </Link>
    );

    const fontAwesomeRender = (
        <Link to={props.tileLink}>
            <Button className="taskLinkButton" style={{
                /*background:'#458bca',*/
                borderRadius: '1em',
                textAlign: 'center',
                height: '13em',
                width: '20em',
                marginBottom: '2em',
            }}><i>{props.icon}</i>
                <Row>
                    <Col>
                        <h4>{props.tileTitle}</h4>
                    </Col>
                </Row>
            </Button>
        </Link>
    );

    const linkRender = (
        <a href={props.tileLink} target="_blank">
            <Button className="taskLinkButton" style={{
                /*background:'#458bca',*/
                borderRadius: '1em',
                textAlign: 'center',
                height: '13em',
                width: '20em',
                marginBottom: '2em',
            }}><i>{props.icon}</i> 
                <Row>
                    <Col>
                        <h4>{props.tileTitle}</h4>
                    </Col>
                </Row>
            </Button>
        </a>
    );

    return (<React.Fragment>

        <Collapse isOpen={props.tileType == null || props.tileType == 'iframe'}>
            {iframeRender}
        </Collapse>

        <Collapse isOpen={props.tileType == 'fontawesome'}>
            {fontAwesomeRender}
        </Collapse>

        <Collapse isOpen={props.tileType == 'link'}>
            {linkRender}
        </Collapse>

    </React.Fragment>);
}

export default MenuTile;

